<template>
  <b-modal
    id="firstlogin"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header
  >
    <AcceptTerms ref="acceptTerms" v-show="Steps.AcceptTerms.active" />
    <ChangePassword ref="changePassword" v-show="Steps.ChangePassword.active" />
    <ConfirmSegments
      ref="confirmSegments"
      v-show="Steps.ConfirmSegments.active"
    />

    <template #modal-footer>
      <div class="w-100 d-flex align-items-center justify-content-between">
        <div class="stepCircles">
          <span
            :class="{
              step: true,
              active: Steps.AcceptTerms.active,
              finish: Steps.AcceptTerms.finishedStep,
            }"
          ></span>
          <span
            :class="{
              step: true,
              active: Steps.ChangePassword.active,
              finish: Steps.ChangePassword.finishedStep,
            }"
          ></span>
          <span
            :class="{
              step: true,
              active: Steps.ConfirmSegments.active,
              finish: Steps.ConfirmSegments.finishedStep,
            }"
          ></span>
        </div>
        <div>
          <button
            type="button"
            class="btn bg-secondary c-white mr-2"
            :disabled="Steps.AcceptTerms.active"
            @click="previousStep()"
          >
            <i class="fas fa-angle-left mr-1"></i>
            Voltar
          </button>
          <button
            type="button"
            :class="`btn bg-${
              Steps.ConfirmSegments.active ? 'success' : 'orange'
            } c-white`"
            :disabled="!canGoToNextStep"
            @click="nextStep()"
          >
            {{ !Steps.ConfirmSegments.active ? 'Próximo' : 'Finalizar' }}
            <i
              :class="`fas fa-${
                !Steps.ConfirmSegments.active ? 'angle-right' : 'check'
              } ml-1`"
            ></i>
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AcceptTerms from './AcceptTerms.vue';
import ChangePassword from './ChangePassword.vue';
import ConfirmSegments from './ConfirmSegments.vue';

export default {
  name: 'ShopkeeperFirstLoginModal',
  components: {
    AcceptTerms,
    ChangePassword,
    ConfirmSegments,
  },
  data() {
    return {
      isMounted: false,
      Steps: {
        AcceptTerms: {
          active: true,
          finishedStep: false,
        },
        ChangePassword: {
          active: false,
          finishedStep: false,
        },
        ConfirmSegments: {
          active: false,
          finishedStep: false,
        },
      },
    };
  },
  computed: {
    stepsObjectsKeys() {
      return Object.keys(this.Steps);
    },
    getCurrentStepName() {
      let currenStepName = '';
      Object.entries(this.Steps).forEach(([key, value]) => {
        if (value.active) {
          currenStepName = key;
        }
      });

      return currenStepName;
    },
    canGoToNextStep() {
      if (!this.isMounted) {
        return false;
      }

      if (this.Steps.AcceptTerms.active) {
        return this.$refs.acceptTerms.validate();
      }

      if (this.Steps.ChangePassword.active) {
        return this.$refs.changePassword.validate();
      }

      if (this.Steps.ConfirmSegments.active) {
        return this.$refs.confirmSegments.validate();
      }

      return false;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    nextStep() {
      const currentStepName = this.getCurrentStepName;
      this.Steps[currentStepName].finishedStep = true;
      this.Steps[currentStepName].active = false;
      this.Steps[this.getNextStepName(currentStepName)].active = true;
    },
    previousStep() {
      const currentStepName = this.getCurrentStepName;
      this.Steps[currentStepName].active = false;
      this.Steps[this.getPreviousStepName(currentStepName)].active = true;
    },
    getPreviousStepName(currentStepName) {
      const previousIndex = this.stepsObjectsKeys.indexOf(currentStepName) - 1;
      return this.stepsObjectsKeys[previousIndex] || 'AcceptTerms';
    },
    getNextStepName(currentStepName) {
      const nextIndex = this.stepsObjectsKeys.indexOf(currentStepName) + 1;
      return this.stepsObjectsKeys[nextIndex] || 'ConfirmSegments';
    },
  },
};
</script>
